<div class="container">
  <div class="col-12">
    <span [innerHTML]="confirmationText">
    </span>
  </div>
</div>
